import { getAddonFlowWayNext } from 'components/common-form/sidePanel/status/cashFlowWayUtils';
import type {
  OwnProps,
  StateProps,
} from 'components/common-form/sidePanel/status/quoted.tradable/Quoted.Tradable.connect';
import { connect } from 'react-redux';
import { addonSelector, getAddonFormAddonAction, getTradeInfosByQuoteId } from 'state/selectors';
import type { AppState } from 'state/state.model';

const mapStateToProps = (state: AppState, { tabId }: OwnProps): StateProps => {
  const solvingMode = addonSelector.getSolveFor(state, tabId)!;
  const remunerationMode = addonSelector.getRemunerationMode(state, tabId);
  const quoteId = addonSelector.getLastQuoteId(state, tabId);
  const quote = addonSelector.getQuoteResult(state, quoteId);
  const addonAction = getAddonFormAddonAction(state, tabId);
  const quoteDetails = addonSelector.getQuoteDetails(state, tabId);

  const { tradeAuthStartTimeInMillis, tradeAuthDurationInMillis } = getTradeInfosByQuoteId(state, quoteId);
  const solveResult = quote?.solveResult!;
  const solveResultFormat = quote?.solveResultFormat!;
  const flowWay = getAddonFlowWayNext(solvingMode, solveResult, remunerationMode, addonAction);
  const fxSpot =
    quoteDetails?.MustDisplayFxSpot === true ? quoteDetails.Greeks?.cells?.filter(x => x.name === 'Spot')[0]! : null;

  return {
    solveResult,
    solveResultFormat,
    solvingMode,
    isMultipleSolvingMode: quoteDetails?.IsMultipleSolvingMode ?? false,
    tradeAuthStartTimeInMillis: tradeAuthStartTimeInMillis!,
    tradeAuthDurationInMillis: tradeAuthDurationInMillis!,
    flowWay,
    fxSpot,
  };
};

export const connectQuotedTradable = connect(mapStateToProps);
